const hours = [
  { day: 'Monday', time: '7:00 AM – 10:00 PM' },
  { day: 'Tuesday', time: '7:00 AM – 10:00 PM' },
  { day: 'Wednesday', time: '7:00 AM – 10:00 PM' },
  { day: 'Thursday', time: '7:00 AM – 10:00 PM' },
  { day: 'Friday', time: '7:00 AM – 11:00 PM' },
  { day: 'Saturday', time: '8:00 AM – 11:00 PM' },
  { day: 'Sunday', time: '8:00 AM – 10:00 PM' },
];

export default function Location() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
            Find Us
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Location & Hours
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="rounded-lg overflow-hidden border border-background-200/60 h-72 md:h-96 lg:h-auto min-h-[300px]">
            <iframe
              title="Ghalib Chai Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.99162569376!2d2.2922926!3d48.8583701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e2964e34e2d%3A0x8ddca9ee380ef7e0!2sEiffel%20Tower!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="space-y-8">
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-4">
                Visit Our Tea House
              </h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-500">
                    <i className="ri-map-pin-line" />
                  </div>
                  <div>
                    <p className="text-foreground-800 font-medium">Address</p>
                    <p className="text-foreground-600 text-sm">
                      123 Artisan Lane, Cultural District
                      <br />
                      City Center, CA 90210
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-500">
                    <i className="ri-phone-line" />
                  </div>
                  <div>
                    <p className="text-foreground-800 font-medium">Phone</p>
                    <p className="text-foreground-600 text-sm">
                      (555) 123-4567
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-500">
                    <i className="ri-mail-line" />
                  </div>
                  <div>
                    <p className="text-foreground-800 font-medium">Email</p>
                    <p className="text-foreground-600 text-sm">
                      hello@ghalibchai.com
                    </p>
                  </div>
                </div>
              </div>
              <a
                href="https://www.google.com/maps/search/?api=1&query=123+Artisan+Lane+Cultural+District"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors"
              >
                Get Directions
                <i className="ri-navigation-line" />
              </a>
            </div>

            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-4">
                Opening Hours
              </h3>
              <div className="space-y-2.5">
                {hours.map((h) => (
                  <div
                    key={h.day}
                    className="flex items-center justify-between text-sm"
                  >
                    <span className="text-foreground-700 font-medium">
                      {h.day}
                    </span>
                    <span className="text-foreground-600">{h.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}